import { gql } from "@apollo/client";

export const GET_MORE_PRODUCT_FRAGMENT = gql`
fragment GetMoreProductFragment on Product {
  id
  name
  code
  inStock
  manufacturer {
    id
    name
  }
  vat
  warranty
  productPrices {
    price
    priceVat
  }
  stocks {
    productID
    quantity
    warehouse {
      id
      code
      name
      regionID
    }
    quantityRealStock
    quantityRealStockHasVat
  }
  updatedAt
  vatPercent
  vatValue
  vatType
}
`;
